var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"notification_label"},[_vm._v(_vm._s(_vm.notification.data.contact_name)+" replied to an email message")]),_vm._v(" "),_c('button-link',{on:{"click":_vm.goToContact}},[_vm._v(_vm._s(_vm.notification.data.contact_name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }